import "../css/constants.css";
import {Disclosure, DisclosureButton, DisclosurePanel,} from '@headlessui/react'
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline'
import {useLocation, useNavigate} from "react-router-dom";
import { animateScroll } from 'react-scroll';
import { Link } from 'react-router-dom';
import { Link as ScrollLink } from 'react-scroll';
import * as React from 'react';
import {useEffect, useRef, useState} from "react";
import GlobalTexts from "../assets/jsons/Global.json";
import {nav} from "framer-motion/m";

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

export default function Navbar({ language, setLanguage }) {
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const timeoutRef = useRef(null);

    const handleMouseEnter = () => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
        setDropdownOpen(true);
    };

    const handleMouseLeave = () => {
        timeoutRef.current = setTimeout(() => {
            setDropdownOpen(false);
        }, 200);
    };

    const location = useLocation();
    const [navigation, setNavigation] = useState([
        { nb: 0, to: GlobalTexts.availableLanguages[language].navigation[0].to, current: false, offset: -68 },
        { nb: 1, to: GlobalTexts.availableLanguages[language].navigation[1].to, current: false, offset: -68 },
        { nb: 3, to: GlobalTexts.availableLanguages[language].navigation[3].to, current: false, offset: -68 },
        { nb: 4, to: GlobalTexts.availableLanguages[language].navigation[4].to, current: false, offset: -68 },
        { nb: 6, to: GlobalTexts.availableLanguages[language].navigation[6].to, current: false, offset: -68 },
        { nb: 7, to: GlobalTexts.availableLanguages[language].navigation[7].to, current: false, offset: -68 },
        { nb: 2, to: GlobalTexts.availableLanguages[language].navigation[2].to, current: false, offset: -68 },
    ]);

    const [navigationRight, setNavigationRight] = useState([
        { nb: 0, to: location.pathname === "/"  ? '#quotation' : '/#quotation', current: false, offset: -110 }
    ]);

    const nav = GlobalTexts.availableLanguages[language].navigation;

    const navigate = useNavigate();

    return (
        <Disclosure as="nav" className="header w-full bg-myWhite">
            {({ open }) => (
                <>
                    <div className="mx-8 md:mx-24 lg-1:mx-24">
                        <div className="relative flex h-[70px] items-center justify-between">
                            <div className="absolute inset-y-0 left-0 flex items-center lg-1:hidden">
                                <DisclosureButton className="relative inline-flex items-center justify-center rounded-md p-2 text-myDarkBlue hover:bg-myDarkBlue hover:text-myWhite transition cursor-pointer focus:outline-none focus:ring-2 focus:ring-inset focus:ring-myDarkBlue">
                                    <span className="absolute -inset-0.5" />
                                    <span className="sr-only">Open main menu</span>
                                    {open ? (
                                        <XMarkIcon className="block h-6 w-6" aria-hidden="true" />
                                    ) : (
                                        <Bars3Icon className="block h-6 w-6" aria-hidden="true" />
                                    )}
                                </DisclosureButton>
                            </div>
                            <div className="flex flex-1 items-center lg-1:justify-start">
                                <div className="absolute inset-y-0 left-1/2 transform -translate-x-1/2 flex items-center lg-1:hidden">
                                    <div className="cursor-pointer" onClick={() => navigate(process.env.REACT_APP_IS_DEVELOPMENT ? "/" : "/")}>
                                        <img
                                            className="h-11 md:h-12 w-auto"
                                            src="/logo.png"
                                            alt="Your Company"
                                            onClick={() => animateScroll.scrollToTop()}
                                        />
                                    </div>
                                </div>
                                <div className={"ml-auto"}>
                                    <select
                                        value={language.toString()}
                                        onChange={(e) => {
                                            setLanguage(Number(e.target.value));
                                        }}
                                        className="lg-1:hidden outline-none appearance-none bg-transparent text-black font-medium cursor-pointer transition"
                                    >
                                        <option value="0">🇫🇷 FR</option>
                                        <option value="1">🇬🇧 EN</option>
                                        <option value="2">🇩🇪 DE</option>
                                    </select>
                                </div>
                                <div className="hidden lg-1:flex items-center cursor-pointer" onClick={() => navigate(process.env.REACT_APP_IS_DEVELOPMENT ? "/" : "/")}>
                                    <img
                                        className="h-8 md:h-12 w-40"
                                        src="/logo.png"
                                        alt="Your Company"
                                        onClick={() => animateScroll.scrollToTop()}
                                    />
                                </div>
                                <div className="hidden sm:ml-6 lg-1:block w-full">
                                    <div className="flex justify-center ml-10 mx-auto w-full">
                                        {[0, 1].map((index) => {
                                            const item = nav[index];
                                            const to = item.to;

                                            if (to.startsWith('#')) {
                                                return (
                                                    <ScrollLink
                                                        key={item.name}
                                                        to={to.substring(1)}
                                                        smooth={true}
                                                        duration={500}
                                                        offset={-68}
                                                        className="text-myDarkBlue hover:text-[#C1A45F] rounded px-3 py-3.5 font-medium cursor-pointer mx-2"
                                                    >
                                                        {item.name}
                                                    </ScrollLink>
                                                );
                                            }
                                            return (
                                                <Link
                                                    key={item.name}
                                                    to={to}
                                                    className="text-myDarkBlue hover:text-[#C1A45F] rounded px-3 py-3.5 font-medium cursor-pointer mx-2"
                                                >
                                                    {item.name}
                                                </Link>
                                            );
                                        })}

                                        <div
                                            className="relative inline-block"
                                            onMouseEnter={handleMouseEnter}
                                            onMouseLeave={handleMouseLeave}
                                        >
                                            <button
                                                className="text-myDarkBlue hover:text-[#C1A45F] rounded px-3 py-3.5 font-medium cursor-pointer mx-2"
                                                aria-haspopup="true"
                                                aria-expanded={dropdownOpen}
                                            >
                                                {language === 0
                                                    ? 'Services'
                                                    : language === 1
                                                        ? 'Services'
                                                        : 'Dienstleistungen'}
                                            </button>

                                            {dropdownOpen && (
                                                <div className="absolute top-full left-0 mt-3 w-max bg-white shadow-lg rounded-md z-10">
                                                    {[3, 4, 6, 7].map((index) => {
                                                        const item = nav[index];
                                                        const to = item.to;

                                                        if (to.startsWith('#')) {
                                                            return (
                                                                <ScrollLink
                                                                    key={item.name}
                                                                    to={to.substring(1)}
                                                                    smooth={true}
                                                                    duration={500}
                                                                    offset={-68}
                                                                    className="block px-4 py-2 text-myDarkBlue hover:bg-[#C1A45F] hover:text-white cursor-pointer"
                                                                >
                                                                    {item.name}
                                                                </ScrollLink>
                                                            );
                                                        }
                                                        return (
                                                            <Link
                                                                key={item.name}
                                                                to={to}
                                                                className="block px-4 py-2 text-myDarkBlue hover:bg-[#C1A45F] hover:text-white cursor-pointer"
                                                            >
                                                                {item.name}
                                                            </Link>
                                                        );
                                                    })}
                                                </div>
                                            )}
                                        </div>

                                        {[2].map((index) => {
                                            const item = nav[index];
                                            const to = item.to;

                                            if (to.startsWith('#')) {
                                                return (
                                                    <ScrollLink
                                                        key={item.name}
                                                        to={to.substring(1)}
                                                        smooth={true}
                                                        duration={500}
                                                        offset={-68}
                                                        className="text-myDarkBlue hover:text-[#C1A45F] rounded px-3 py-3.5 font-medium cursor-pointer mx-2"
                                                    >
                                                        {item.name}
                                                    </ScrollLink>
                                                );
                                            }
                                            return (
                                                <Link
                                                    key={item.name}
                                                    to={to}
                                                    className="text-myDarkBlue hover:text-[#C1A45F] rounded px-3 py-3.5 font-medium cursor-pointer mx-2"
                                                >
                                                    {item.name}
                                                </Link>
                                            );
                                        })}
                                    </div>
                                </div>



                                <div className="hidden lg-1:flex items-center ml-auto">
                                    <div className="flex items-center space-x-2">
                                        <div className="flex justify-end ml-auto w-max">
                                            {navigationRight.map((item) => {
                                                if (item.to.startsWith('/')) {
                                                    return (
                                                        <Link
                                                            key={item.name}
                                                            to={item.to}
                                                            className={classNames(
                                                                'appearance-none outline-none h-min bg-myDarkBlue border-4 rounded-md leading-none px-3 font-medium cursor-pointer border-myDarkBlue hover:border-[#C1A45F] py-3 mx-2 hover:bg-myDarkBlue transition flex items-center justify-center'
                                                            )}
                                                            aria-current={item.current ? 'page' : undefined}
                                                        >
                                                            {GlobalTexts.availableLanguages[language].navigation[8].name}
                                                        </Link>
                                                    );
                                                } else if (item.to.startsWith('#')) {
                                                    return (
                                                        <ScrollLink
                                                            key={item.name}
                                                            to={item.to.substring(1)}
                                                            smooth={true}
                                                            duration={500}
                                                            offset={item.offset || 0}
                                                            className={classNames(
                                                                'bg-myDarkBlue border-4 rounded-md leading-none px-42font-medium cursor-pointer border-myDarkBlue hover:border-[#C1A45F] mx-2 hover:bg-myDarkBlue transition h-min py-3 px-3 flex items-center justify-center'
                                                            )}
                                                            aria-current={item.current ? 'page' : undefined}
                                                        >
                                                            {GlobalTexts.availableLanguages[language].navigation[8].name}
                                                        </ScrollLink>
                                                    );
                                                } else {
                                                    return (
                                                        <a
                                                            key={item.name}
                                                            href={item.to}
                                                            rel="noopener noreferrer"
                                                            className={classNames(
                                                                'bg-myDarkBlue border-4 rounded-md leading-none px-3 font-medium cursor-pointer border-myDarkBlue hover:border-[#C1A45F] mx-2 hover:bg-myDarkBlue transition h-min py-3 flex items-center justify-center'
                                                            )}
                                                            aria-current={item.current ? 'page' : undefined}
                                                        >
                                                            {GlobalTexts.availableLanguages[language].navigation[8].name}
                                                        </a>
                                                    );
                                                }
                                            })}
                                        </div>

                                        <div className="relative">
                                            <select
                                                value={language.toString()}
                                                onChange={(e) => {
                                                    setLanguage(Number(e.target.value));
                                                }}
                                                className="appearance-none outline-none bg-myDarkBlue border-4 border-myDarkBlue hover:border-[#C1A45F] rounded-md px-2 py-2 font-medium cursor-pointer transition"
                                            >
                                                <option value="0">🇫🇷 FR</option>
                                                <option value="1">🇬🇧 EN</option>
                                                <option value="2">🇩🇪 DE</option>
                                            </select>
                                        </div>

                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Mobile menu avec DisclosurePanel */}
                    <DisclosurePanel className="lg-1:hidden">
                        <div className="px-4 py-4 border-t border-b shadow-xl space-y-2">
                            {navigation.concat(navigationRight).map((item, index, array) => {
                                const isLast = index === array.length - 1;
                                const isInternalLink = item.to.startsWith("/");
                                const label = isLast
                                    ? GlobalTexts.availableLanguages[language].navigation[8].name
                                    : GlobalTexts.availableLanguages[language].navigation[item.nb].name;

                                const commonClasses = classNames(
                                    'text-myDarkBlue hover:text-[#C1A45F]',
                                    'rounded text-lg font-medium py-2 px-3 w-full transition flex items-center'
                                );

                                const lastClasses = classNames(
                                    'bg-myDarkBlue text-white border-4 border-myDarkBlue hover:border-[#C1A45F] mt-6 ml-auto md:ml-0',
                                    'rounded-md px-4 py-2 font-medium w-max flex items-center'
                                );

                                const linkProps = {
                                    key: item.name,
                                    className: isLast ? lastClasses : commonClasses,
                                    'aria-current': item.current ? 'page' : undefined
                                };

                                return (
                                    <DisclosureButton key={item.name} as="div" className="w-full">
                                        {isInternalLink ? (
                                            <a href={GlobalTexts.availableLanguages[language].navigation[item.nb].to} {...linkProps}>
                                                {label}
                                            </a>
                                        ) : (
                                            <Link to={GlobalTexts.availableLanguages[language].navigation[item.nb].to} smooth={true} duration={500} offset={item.offset} {...linkProps}>
                                                {label}
                                            </Link>
                                        )}
                                    </DisclosureButton>
                                );
                            })}
                        </div>
                    </DisclosurePanel>

                </>
            )}
        </Disclosure>
    )
}